import { Link } from 'react-router-dom';
import { dimensions } from '@/mocks/dimensions';
import { navItems, site } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-secondary-100">
      <div className="w-full px-4 py-14 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4 md:gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading text-xl font-bold">
                爆
              </span>
              <span className="font-heading text-xl font-bold text-background-50">{site.name}</span>
            </div>
            <p className="mt-5 max-w-md font-body text-sm leading-relaxed text-secondary-200">
              {site.tagline}
            </p>
            <p className="mt-5 font-label text-sm text-secondary-300">
              投稿与线索：
              <a href={`mailto:${site.email}`} className="ml-1 text-accent-300 hover:text-accent-200" rel="nofollow">
                {site.email}
              </a>
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50">
              <Link to="/dossiers" className="hover:text-accent-300">拆解维度</Link>
            </h4>
            <ul className="mt-5 space-y-3">
              {dimensions.map((dim) => (
                <li key={dim.id}>
                  <Link
                    to={`/dossiers?dimension=${dim.id}`}
                    className="font-label text-sm text-secondary-200 transition-colors hover:text-accent-300"
                  >
                    {dim.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50">
              <Link to="/" className="hover:text-accent-300">站点导航</Link>
            </h4>
            <ul className="mt-5 space-y-3">
              {navItems.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="font-label text-sm text-secondary-200 transition-colors hover:text-accent-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-secondary-800 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-label text-xs text-secondary-300">
            © {site.since}-2026 {site.name} · 内容仅供线索梳理参考
          </p>
          <p className="font-label text-xs text-secondary-300">
            所有时间线节点均标注来源时段，欢迎读者交叉核对
          </p>
        </div>
      </div>
    </footer>
  );
}